import createCsvAndDownload from '@/shared/utils/createCsvAndDownload'

export const EUA_PRICE_HISTORY_CSV_FILENAME = 'eua-price-history.csv'

export type EuaPriceHistoryCsvColumns = {
  date: string
  price: string
}

export type EuaPriceHistoryRow = {
  tradeDate: string
  price: string
}

export function formatTradeDateForExport(tradeDate: string): string {
  return tradeDate.slice(0, 10)
}

export function buildEuaPriceHistoryCsvRows(
  history: EuaPriceHistoryRow[],
  columns: EuaPriceHistoryCsvColumns
): Record<string, string>[] {
  return history.map(({ tradeDate, price }) => ({
    [columns.date]: formatTradeDateForExport(tradeDate),
    [columns.price]: price
  }))
}

export function downloadEuaPriceHistoryCsv(
  history: EuaPriceHistoryRow[],
  columns: EuaPriceHistoryCsvColumns
): void {
  const rows = buildEuaPriceHistoryCsvRows(history, columns)
  createCsvAndDownload(EUA_PRICE_HISTORY_CSV_FILENAME, rows, {
    columns: [columns.date, columns.price]
  })
}
